import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { axiosClient, queryClient } from "../../clients";

import type { IMemberBooks } from "./routeType";

import type { IPickDelete } from "@/api";
import { getApi } from "@api/apiPath";
import { useGetAllMemberBooks } from "@/api/members/books/getAll";
import { useGetMemberBook } from "@/api/members/books/get";

const { getPath } = getApi("members.books.delete");

type IExtractedRouteType = IMemberBooks["bookSingleDelete"];

export type IDeleteMemberBook = IPickDelete<IExtractedRouteType>;

const deleteMemberBook: MutationFunction<
  IDeleteMemberBook["response"],
  IDeleteMemberBook["variables"]
> = ({ memberId, bookId }) => {
  return axiosClient.delete(getPath({ memberId, bookId }));
};

export const useDeleteMemberBook = createMutation({
  mutationFn: deleteMemberBook,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberBooks.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberBook.getKey({ memberId }),
    });
  },
});
